import React from "react";

import { Button, Col, Dropdown, Row } from "react-bootstrap";

import { Calendar, Filter, RefreshCw } from "react-feather";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import { selectCurrentUser } from "../../redux/slices/authSlice";
// import { JobActions, TaskActions } from "../../utils/api";

const Header = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectCurrentUser);

  const retrieveData = () => {
    //   TaskActions.getAllTasks().then((tasks) => {
    //     dispatch(receivedTasks(tasks));
    //   })

    //   JobActions.getJobs().then((jobs) => {
    //     dispatch(receivedJobs(jobs))
    //   })
  }

  return (
    <Row className="mb-2 mb-xl-3">
      <Col xs="auto" className="d-none d-sm-block">
        <h3>Admin Dashboard</h3>
        <br />
        <h4>Welcome back, {user && user.firstName}</h4>
      </Col>

      <Col xs="auto" className="ms-auto text-end mt-n1">
        <Button variant="primary" className="shadow-sm" onClick={() => retrieveData()}>
          <RefreshCw className="feather" />
        </Button>
      </Col>
    </Row>
  );
};

export default Header;
